import { compose } from 'lodash/fp'
import React from 'react'
import withReduxForm from '../withReduxForm'
import DateRangeInput, { IDateRangeInputProps } from './DateRangeInput'
import withCustomFormat from './withCustomFormat'
import withRedux from './withRedux'

const ConnectedDateRangeInput: React.ComponentType<
  IDateRangeInputProps
> = compose(
  withReduxForm,
  withCustomFormat,
  withRedux,
)(DateRangeInput)

export default ConnectedDateRangeInput
export { DateRangeInput }

export enum RangeType {
  Start = 'start',
  End = 'end',
}
